"use strict";

exports.__esModule = true;
exports.default = void 0;

require("./waves.less");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireDefault(require("../core/component"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _device = _interopRequireDefault(require("../libs/device"));

var _debug = _interopRequireDefault(require("debug"));

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var log = (0, _debug.default)('common.waves');
/**
 *
 */

var Waves = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Waves, _Component);

  function Waves(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {};

    _this.handlerMouseUp = function () {
      _this.state.end = Date.now();
      if (_device.default.moblie) _this.end && _this.end(_this.state.end - _this.state.start);
    };

    _this.handlerMouseDown = function (e) {
      //log('handlerMouseDown')
      if (_this.props.disabled === true) return;
      _this.state.start = Date.now();

      var div = _tools.default.getPosition(_this.waves);

      var animation = (0, _jquery.default)("<div class=\"c-waves-animation no-select\">");
      (0, _jquery.default)(_this.waves).append(animation);
      var pageX = e.pageX || e.touches[0].pageX;
      var pageY = e.pageY || e.touches[0].pageY;

      var _top = pageY - div.top;

      var _topc = div.height / 2 - 10;

      var _bottom = div.height - _top;

      var _left = pageX - div.left;

      var _leftc = div.width / 2 - 10;

      var _right = div.width - _left;

      var _scale = 'scale(1)'; // 横向

      if (_this.waves.clientWidth > _this.waves.clientHeight) {
        _scale = 'scale(' + (Math.max(_right, _left) + 10) / 10 + ')';
      } // 竖向
      else {
        _scale = 'scale(' + (Math.max(_top, _bottom) + 10) / 10 + ')';
      }

      var position = {
        top: _this.props.center ? _topc : _top - 10,
        left: _this.props.center ? _leftc : _left - 10,
        transform: _scale,
        opacity: 1,
        "background-color": _this.props.color,
        "transition-duration": _this.props.duration * 2 + "ms",
        "transition-timing-function": "cubic-bezier(0.250, 0.460, 0.450, 1)"
      };
      (0, _jquery.default)(animation).css(position);

      _this.end = function (timer) {
        var surplus = _this.props.duration - timer;

        if (_device.default.moblie) {
          surplus = surplus > 0 ? surplus : 0;
        } else {
          surplus = 0;
        }

        var finishStyle = {
          top: _this.props.center ? _topc : _top - 10,
          left: _this.props.center ? _leftc : _left - 10,
          transform: _scale,
          opacity: 0,
          "background-color": _this.props.color,
          "transition-duration": _this.props.duration + surplus + "ms",
          "transition-timing-function": "cubic-bezier(0.250, 0.460, 0.450, 0.940)"
        };
        (0, _jquery.default)(animation).css(finishStyle);
        setTimeout(function () {
          animation.remove();
        }, _this.props.duration + surplus);
      };

      if (!_device.default.moblie) _this.end(0);
    };

    return _this;
  }

  var _proto = Waves.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('c-waves'),
      onMouseDown: !_device.default.moblie ? this.handlerMouseDown : null,
      onMouseUp: !_device.default.moblie ? this.handlerMouseUp : null,
      onTouchStart: _device.default.moblie ? this.handlerMouseDown : null,
      onTouchEnd: _device.default.moblie ? this.handlerMouseUp : null
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: function ref(waves) {
        return _this2.waves = waves;
      },
      className: "c-waves-inner"
    }));
  };

  return Waves;
}(_component.default); //Enhance(Waves, {}, 'Waves')


Waves.displayName = "Waves";
Waves.defaultProps = {
  color: 'rgba(255, 255, 255, 0.2)',
  center: false,
  duration: 500
};
var _default = Waves;
exports.default = _default;
module.exports = exports.default;